import React from 'react';

export default class Page7 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content" id="yui_3_17_2_1_1594731883316_34">
                    <div role="main" id="yui_3_17_2_1_1594731883316_33"><span id="maincontent"/>
                        <section id="yui_3_17_2_1_1594731883316_32">
                            <div className="" id="yui_3_17_2_1_1594731883316_31">
                                <div className="ilead-rgt " id="yui_3_17_2_1_1594731883316_30">
                                    <div className="innerpadding" id="yui_3_17_2_1_1594731883316_29">
                                        <div className="ilead-contentarea"
                                             id="yui_3_17_2_1_1594731883316_28">
                                            <div className="mobile-scroll">
                                                <table width="100%" border="0" cellSpacing="0"
                                                       cellPadding="0" className="ilead_v_sport tablesrink">
                                                    <tbody>
                                                    <tr>
                                                        <th width="25%" align="left" valign="center"
                                                            className=" ">Situation
                                                        </th>
                                                        <th width="25%" align="left" valign="center">1:1
                                                        </th>
                                                        <th width="25%" align="left" valign="center">Small
                                                            Group
                                                        </th>
                                                        <th width="25%" align="left" valign="top"
                                                            className="">Large Group
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%" align="left" valign="top"
                                                            className="lightgreen"><strong>Report</strong>


                                                        </td>
                                                        <td width="25%" align="left" valign="top"
                                                            className="lightgreen"><p>If well laid out in
                                                            stages,
                                                            can be effective –
                                                            depends on individual
                                                            preferences for
                                                            assimilating information
                                                            in this way. For example,
                                                            Introverts (1 on MBTI),
                                                            like to receive
                                                            information in this
                                                            way, to reflect on it.
                                                        </p>
                                                        </td>
                                                        <td width="25%" align="left" valign="top"
                                                            className="lightgreen"><p>As per 1:1.</p>

                                                        </td>
                                                        <td width="25%" align="left" valign="top"
                                                            className="lightgreen"><p>Limited effectiveness
                                                            and
                                                            not practical.</p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%" align="left" valign="top"
                                                            className="darkgreen"><strong>Email</strong>


                                                        </td>
                                                        <td width="25%" align="left" valign="top"
                                                            className="darkgreen"><p>Poor – may be useful
                                                            for short simple ideas or
                                                            follow-on explanations.
                                                        </p>
                                                        </td>
                                                        <td width="25%" align="left" valign="top"
                                                            className="darkgreen"><p>Poor as per 1:1.</p>

                                                        </td>
                                                        <td width="25%" align="left" valign="top"
                                                            className="darkgreen"><p>Not effective.</p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%" align="left" valign="top"
                                                            className="lightgreen"><strong>Video
                                                            Conference</strong>


                                                        </td>
                                                        <td width="25%" align="left" valign="top"
                                                            className="lightgreen"><p>Good method if link
                                                            is effective and allows
                                                            genuine sharing of
                                                            information.
                                                        </p>
                                                        </td>
                                                        <td width="25%" align="left" valign="top"
                                                            className="lightgreen"><p>Limited. The key
                                                            problem is allowing
                                                            people to raise
                                                            questions.</p>

                                                        </td>
                                                        <td width="25%" align="left" valign="top"
                                                            className="lightgreen"><p>Very limited – really
                                                            only
                                                            for presenting to a group
                                                            rather than getting
                                                            feedback from it.</p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%" align="left" valign="top"
                                                            className="darkgreen"><strong>Telephone</strong>


                                                        </td>
                                                        <td width="25%" align="left" valign="top"
                                                            className="darkgreen"><p>Limited to verbal
                                                            rather
                                                            than non-verbal
                                                            feedback. Can be
                                                            difficult to retain the
                                                            other person‘s interest.
                                                        </p>
                                                        </td>
                                                        <td width="25%" align="left" valign="top"
                                                            className="darkgreen"><p>Not effective – limited
                                                            verbal feedback and no
                                                            non-verbal feedback.</p>

                                                        </td>
                                                        <td width="25%" align="left" valign="top"
                                                            className="darkgreen"><p>Not effective.</p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%" align="left" valign="top"
                                                            className="lightgreen">
                                                            <strong>Graphical</strong>


                                                        </td>
                                                        <td width="25%" align="left" valign="top"
                                                            className="lightgreen"><p>Usually used in
                                                            conjunction with other
                                                            methods. In face-toface
                                                            communications,
                                                            can enable drawing
                                                            concepts on paper as
                                                            you go through the
                                                            ideas and the use of
                                                            flow charts, etc., to
                                                            present information in
                                                            a step-by-step manner.
                                                        </p>
                                                        </td>
                                                        <td width="25%" align="left" valign="top"
                                                            className="lightgreen"><p>Flipcharts are very
                                                            useful in small groups
                                                            to allow you to set out
                                                            your thoughts on paper
                                                            and develop concepts
                                                            with others.</p>

                                                        </td>
                                                        <td width="25%" align="left" valign="top"
                                                            className="lightgreen"><p>Very useful – but
                                                            don‘t
                                                            try to ‘draw as you go‘ with
                                                            larger groups. Graphics
                                                            need to be prepared in
                                                            advance and made
                                                            suitable for large screen
                                                            presentation.</p>

                                                        </td>
                                                    </tr>


                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="border_subtitle">Summary</div>
                                            <p>The best ideas are often the simplest and you now have
                                                strategies for simplifying even the most
                                                complicated concepts. You will also have a better
                                                understanding of your own preferred ways of
                                                assimilating and communicating complicated information
                                                simply, clearly and concisely.</p>

                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>NEXT STEPS
                                            </div>
                                            <p>You should by now have more of a sense of how to make complex
                                                ideas and problems more
                                                simple and manageable. Here are some suggestions about what
                                                to do next, although this list is
                                                by no means exhaustive:</p>
                                            <div className="border_subtitle">Gather feedback on existing
                                                performance
                                            </div>
                                            <p>You may find it useful to ask for formal or informal
                                                feedback. This may help you to understand
                                                how other people perceive you and get advice about where you
                                                can make modifications or
                                                improvements. You can also use this information to manage
                                                people‘s future expectations about
                                                your approach as well as to monitor your progress.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page8')}
                                                     className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}